import React from "react"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import classes from "./OhCanceledButton.module.scss"

const OhCanceledButton = props => {
  const { setShowCancelModal } = props

    const [t] = useTranslation()

  return (
    <div className={classes["container"]}>
      <Button
        color="danger"
        fullWidth
        onClick={() => setShowCancelModal(true)}
      >
        {t("لغو_سفارش")}
      </Button>
    </div>
  )
}

export default OhCanceledButton